/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import z from "./ListItem.mjs";
import x from "./ListGroupItem.mjs";
import { areSame as C, getItemValue as N } from "./utils.mjs";
import { provideLocalizationService as F, registerForLocalization as M } from "@progress/kendo-react-intl";
import { nodata as R, messages as $ } from "../messages/index.mjs";
class A extends t.Component {
  renderItems() {
    const {
      textField: l,
      valueField: r,
      groupField: e,
      groupMode: o,
      isMultiColumn: f,
      optionsGuid: n,
      skip: d = 0,
      virtual: p,
      focusedIndex: c,
      hasDuplicates: v,
      highlightSelected: m = !0,
      value: u,
      data: E,
      itemRender: w,
      groupHeaderItemRender: D
    } = this.props, y = Array.isArray(u);
    let k = 0;
    return E.map((s, i) => {
      const g = d + i, I = d + i + k, L = v ? u ? c === i : !1 : s.disabled ? !1 : m && (!y && C(s, u, r) || y && u.findIndex((b) => C(b, s, r)) !== -1);
      let a, h, S;
      return i > 0 && e !== void 0 && (h = N(s, e), S = N(E[i - 1], e), h && S && h !== S && (a = h)), a !== void 0 && o === "modern" && (k += 1), [
        a !== void 0 && o === "modern" && /* @__PURE__ */ t.createElement(
          x,
          {
            id: `option-${n}-${I}`,
            virtual: p,
            key: g + "-group-item",
            group: a,
            isMultiColumn: f,
            render: D
          }
        ),
        /* @__PURE__ */ t.createElement(
          z,
          {
            id: `option-${n}-${a !== void 0 && o === "modern" ? I + 1 : I}`,
            virtual: p,
            dataItem: s,
            groupMode: o,
            selected: L,
            focused: c === i,
            index: g,
            key: g,
            onClick: this.props.onClick,
            textField: l,
            group: a,
            render: w,
            disabled: s.disabled
          }
        )
      ];
    });
  }
  renderNoValueElement(l) {
    const r = this.props.noDataRender, e = /* @__PURE__ */ t.createElement("div", { className: "k-nodata" }, /* @__PURE__ */ t.createElement("div", null, l.toLanguageString(R, $[R])));
    return r ? r.call(void 0, e) : e;
  }
  render() {
    const l = F(this), {
      id: r,
      show: e,
      wrapperCssClass: o,
      wrapperStyle: f,
      listStyle: n,
      listRef: d,
      wrapperRef: p,
      listClassName: c = "k-list-ul",
      ariaSetSize: v
    } = this.props, m = this.renderItems();
    return m.length ? /* @__PURE__ */ t.createElement(
      "div",
      {
        className: o,
        style: f,
        ref: p,
        onMouseDown: this.props.onMouseDown,
        onBlur: this.props.onBlur,
        onScroll: this.props.onScroll,
        unselectable: "on"
      },
      /* @__PURE__ */ t.createElement(
        "ul",
        {
          id: r,
          role: "listbox",
          "aria-hidden": e ? void 0 : !0,
          "aria-setsize": v,
          className: c,
          ref: d,
          style: n
        },
        m
      ),
      this.props.scroller && /* @__PURE__ */ t.createElement("div", { className: "k-height-container" }, this.props.scroller)
    ) : this.renderNoValueElement(l);
  }
}
M(A);
export {
  A as default
};
